const AdminTooltip = ({ text, className = "", fontSize = "12px", boxShadow = "0 2px 8px rgba(0,0,0,0.2)", width = "auto", position = "absolute", top, left, right, bottom, padding = "6px 12px", borderRadius = "6px", bgColor = "#000", textColor = "#fff" }) => {
    const style = { position, top, left, right, bottom, width, borderRadius, padding, backgroundColor: bgColor, color: textColor, fontSize, boxShadow, whiteSpace: "nowrap" }
    return (
        <span className={`admin-tooltip ${className}`} style={style}>
            {text}
        </span>
    );
};


export default AdminTooltip
